/*
 *
 * Mobile Slider Menu Module
 * @notes This needs some work as it's too specific for MSP and repeats itself often
 *
 */

class MobileMenu {
  constructor() {

    document.addEventListener("click", (e) => {
      //if i am an open menu, do nothing
      if (e.target.closest('.jumbo-menu') || e.target.classList.contains('jumbo-menu')) {
        return null
      }
      //otherwise check...
      else {
        //if i am a menu item
        if (e.target.closest('.main-menu__item__link') || e.target.closest('.main-menu__item__link')) { 
          const par = e.target.closest('.main-menu__item')
          //if my parent is active
          if (par.classList.contains('active')) {
            par.classList.remove('active')
          }
          //otherwise
          else {
            if (document.querySelector('.main-menu__item.active')) {
              document.querySelector('.main-menu__item.active').classList.remove('active')
            }
            par.classList.add('active')
          }
        }
        else {
          if (document.querySelector('.main-menu__item.active') ) { 
            document.querySelector('.main-menu__item.active').classList.remove('active')
          }
        }  
      }
    })

    //Queries for menu items
    const bars = document.querySelector("#mobile-menu-trigger"),
      menu = document.querySelector("#mobile-menu-container"),
      mobileMenuParentItems = document.querySelectorAll(
        ".mobile-menu-container .menu-item-has-children > a"
      ),
      popUpTriggers = document.querySelectorAll(".trigger-popup-banner"),
      popUpBanner = document.querySelector(".popup-banner");

    for (var i = 0; i < popUpTriggers.length; i++) {
      var trigger = popUpTriggers[i];
      trigger.addEventListener("click", function (e) {
        e.preventDefault();
        if (
          popUpBanner.classList.contains("popped") &&
          this.classList.contains("active")
        ) {
          popUpBanner.classList.remove("popped");
          this.classList.remove("active");
         
        } else {
          this.classList.add("active");
          popUpBanner.classList.add("popped");
          popUpBanner.innerHTML = this.innerHTML;
          popUpBanner.setAttribute("href", this.getAttribute("href"));
          
        }
      });
    }

    //Listen for clicks on the mobile menu
    bars.addEventListener("click", function (e) {
      e.preventDefault();
      if (menu.classList.contains("open")) {
        document.body.classList.remove('mobile-menu-open');
        menu.classList.remove("open");
        this.classList.remove("icon--close");
        this.classList.add("icon--bars");
        for (var i = 0; i < mobileMenuParentItems.length; i++) {
          var parentItem = mobileMenuParentItems[i];
          parentItem.parentElement.classList.remove("open");
          parentItem.parentElement
            .querySelector("div")
            .classList.remove("open");
        }
      } else {
        menu.classList.add("open");
        this.classList.remove("icon--bars");
        this.classList.add("icon--close");
        document.body.classList.add('mobile-menu-open');
      }
    });
    //Listen for clicks on the parent items to load level two
    for (var i = 0; i < mobileMenuParentItems.length; i++) {
      var parentItem = mobileMenuParentItems[i];

      //Parent listen item function
      parentItem.addEventListener("click", function (e) {
        e.preventDefault();
        if (
          this.parentElement.querySelector("div").classList.contains("open")
        ) {
          this.parentElement.classList.remove("open");
          this.parentElement.querySelector("div").classList.remove("open");
        } else {
          this.parentElement.classList.add("open");
          this.parentElement.querySelector("div").classList.add("open");
        }
      });

      //Back button functions
      parentItem.parentElement
        .querySelector(".back")
        .addEventListener("click", function (e) {
          e.preventDefault();
          const menuItem = this.closest(".mobile-menu__item");
          if (
            menuItem.classList.contains("open")
          ) {
            menuItem.classList.remove("open");
            menuItem.querySelector("div").classList.remove("open");
          } else {
            menuItem.classList.add("open");
            menuItem.querySelector("div").classList.add("open");
          }
        });
    }
  }
};

export default new MobileMenu;
